/**
 * Cloudflare Turnstile client constants (VM-954).
 *
 * The token is validated server-side by `apps/vidmax-api/src/auth/turnstileGuard.ts`
 * before Auth.js starts a sign-in, so every surface that initiates sign-in must
 * ship the token under `TURNSTILE_TOKEN_FIELD`.
 */

/** Public sitekey — safe in the bundle. The matching secret lives in Infisical, server-side only. */
export const TURNSTILE_SITE_KEY = "0x4AAAAAAA1m_MtoUFJrgrhd"

/** Field name Cloudflare's own widget uses; the server reads the same name. */
export const TURNSTILE_TOKEN_FIELD = "cf-turnstile-response"

/**
 * Placeholder token used when the widget is skipped outside production. The
 * server-side guard bypasses non-production hosts, so this value never reaches
 * Siteverify — and a prod host enforces regardless of what the client sends.
 */
export const TURNSTILE_DEV_BYPASS_TOKEN = "dev-bypass-token"
